import * as angular from 'angular';
import {IController} from 'angular';

export class BillingAccountSelectListCtrl implements IController {
  options: any;
  selectedId: any;
  branchIds: any;
  ngPlaceholder: any;
  excludeIds: any;
  onChange: Function;


  private billingAccountsRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;

  constructor(private $billingAccounts, private $infiniteScroll, private $log) {
  }

  $onInit() {
    if (!this.options) {
      this.billingAccountsRef = this.$billingAccounts();
      this.loadLimit = 20;

      this.billingAccountsRef.$query(this._getQueryPayload());
      this.infiniteScroll = this.$infiniteScroll(this.billingAccountsRef, this.loadLimit, {getFullData: true});
    }
  }

  $onChanges(changes) {
  }

  submitQuery(query) {
    this.queryString = query;
    if (!this.options) {
      this._reload();
    }
  }

  private _reload() {
    this.billingAccountsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.queryString,
      isDemand: true,
      branchIds: this.branchIds,
      sort: 'name,asc'
    };
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('billingAccountSelectList', {
    bindings: {
      options: '<?',
      selectedId: '<',
      branchIds: '<?',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      onChange: '&'
    },
    template: require('./billing-account-select-list.html').default,
    controller: BillingAccountSelectListCtrl
  });
